import { INavbarConfig, ISpacer, ISeparator, IMenuItem, NavigationBarEvents, DataEvents } from "@dhx/ts-navbar";
import { ICustomHTMLButton, IText, INavItem } from "@dhx/ts-toolbar";
import { IEventSystem } from "@dhx/ts-common/events";
import { ITreeCollection } from "@dhx/ts-data";

export interface ISidebarConfig extends INavbarConfig {
	width?: number | string;
	minWidth?: number | string;
	collapsed?: boolean;
}

export enum SidebarEvents {
	toggle = "toggle"
}

export type ISidebarElement =  ICustomHTMLButton |
	ISeparator | ISpacer | IText  | INavItem | IMenuItem;

export interface ISidebar {
	config: ISidebarConfig;
	events: IEventSystem<NavigationBarEvents | DataEvents | SidebarEvents>;
	data: ITreeCollection<ISidebarElement>;

	toggle(): void;
	isCollapsed(): boolean;
}